<template>
  <v-container class="A4 mb-3" id="printMe">
    <span v-html="styleText"></span>
    <v-row class="d-flex my-header" style="justify-content: space-between;">
      <div class="d-flex print-hidden" style="padding-left: 30px">
        <v-select class="append-select" v-model="customer.company_id" :items="companyOptions" item-text="name"
          item-value="id" menu-props="auto" hide-details label="所属拆迁公司" single-line style="max-width: 120px"></v-select>
        <span style="margin: 0 20px"></span>
        <v-select class="append-select" v-model="customer.transition_is_company" :items="stateOptions"
          item-text="display_name" item-value="key" menu-props="auto" hide-details label="过渡费是否由拆迁公司计算" single-line
          style="max-width: 170px;"></v-select>
      </div>
      <div>
        <v-btn @click="goBack" class="primary my-btn my-1">
          <i class="mdi mdi-arrow-left-bold"></i>返回
        </v-btn>
        <v-btn @click="confirm" class="primary my-btn  ml-1 my-1">
          <i class="mdi mdi-card-account-details"></i>保存
        </v-btn>
        <v-btn @click="readIdCard" class="primary my-btn  ml-1 my-1">
          <i class="mdi mdi-card-account-details"></i>读取户主身份证
        </v-btn>
        <v-btn v-print="printObj" class="primary my-btn my-1 ml-1">
          <i class="mdi mdi-printer"></i>打印
        </v-btn>
        <span class="my-1 ml-1 print-hidden"><AddRemindDialog /></span>
        <span class="my-1 ml-1 print-hidden"><UpdateTransitionDialog /></span>
        
      </div>
      
    </v-row>
    <v-row class="d-flex my-header print-hidden" style="justify-content: space-between;padding-top: 10px;" v-if="customer.note">
      <div class="d-flex " style="padding-left: 30px;color:red;font-size:22px;" >
        <v-icon style="color:red;font-size:22px;" >{{ icons.remind.icon }}</v-icon>
        备注：{{ customer.note }}
      </div>
      
    </v-row>
    <v-row class="d-flex my-header print-hidden" style="justify-content: space-between;padding-top: 10px;" v-if="customer.remind">
      <div class="d-flex " style="padding-left: 30px;color:red;font-size:22px;" >
        <v-icon style="color:red;font-size:22px;" >{{ icons.remind.icon }}</v-icon>
        注意：{{ customer.remind }}
      </div>
      
    </v-row>
    <h1 class="head-1">
      嘉善县魏塘街道过渡费计算表
    </h1>
    <h1 class="head-1">
      （副联）
    </h1>
    <table border="1" bordercolor="#000000">
      <tr>
        <td colspan="2" class="head-2">姓名</td>
        <td colspan="3" class="input-text1">
          {{ customer.name }}<br><input type="text" name="name" style="border:none;border-bottom:1.5px solid #555555;"
            class="no-border" v-model="customer.cardid" />
        </td>
        <td colspan="2" class="head-2 six_word">腾空时间</td>
        <td colspan="2" class="input-text1" v-if="customer.empty_time">{{ customer.empty_time }}</td>
        <td colspan="2" class="input-text1" v-else><v-menu
            v-model="empty_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="empty_time"
                label="腾空时间"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                style="width:150px !important;"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="empty_time"
              @input="empty_menu = false"
            ></v-date-picker>
          </v-menu></td>
        <td colspan="2" class="head-2 six_word">确认安置面积</td>
        <td colspan="2" class="input-text1">{{
          customer.myarea
        }}㎡</td>

      </tr>
      <tr>
        <td colspan="2" class="head-2">安置人员</td>
        <td colspan="11" class="input-text" style="text-align:left"> <input type="text" name="name"
            style="border:none;border-bottom:1.5px solid #555555;width:70%" class="no-border"
            v-model="customer.transition_user" /></td>
      </tr>
      <tr>
        <td colspan="2" class="head-2">总过渡费</td>
        <td colspan="2" class="input-text">{{ customer.transition.transition_total }}</td>

        <td class="input-text12">元</td>
        <td colspan="8" class="input-text"></td>
      </tr>
      <tr>
        <td colspan="2" class="head-2">已发放过渡费</td>
        <td colspan="2" class="input-text">{{ customer.transition.transition_issued }}</td>

        <td class="input-text12">元</td>
        <td colspan="8" class="input-text"></td>
      </tr>

      <tr>
        <td colspan="2" class="head-2">差价</td>
        <td colspan="2" class="input-text">{{ customer.transition.transition_diff }}</td>

        <td class="input-text12">元</td>
        <td colspan="8" style="text-align:left;">“-”代表超发过渡费，“+”代表需补发过渡费</td>
      </tr>



    </table>

    <v-row class="d-flex justify-space-between note-footer">
      <span style="display: inline-block; text-align: left;width: 50%">结算单位（盖章）：
        <!-- :value="user_name" -->
        <input type="text" name="name" style="border:none;border-bottom:1.5px solid #555555;" class="my-input" />
      </span>
      <span style="display: inline-block; text-align: right;width: 50%">户主签字：
        <!-- :value="user_name" -->
        <input type="text" name="name" style="border:none;border-bottom:1.5px solid #555555;" class="my-input" />
      </span>

      <div class="indent" style="width:100%;padding: 20px 30px 0 40px;text-align: right;font-size: 16px;">
        <span>{{ nowTime }}</span>
      </div>

    </v-row>
    <br />

    <p style="text-align:center;">
      <span>X————————————————————————————————————————————X</span>
    </p>
    <br />
    <h1 class="head-1">
      嘉善县魏塘街道过渡费计算表
    </h1>
    <h1 class="head-1">
      （正联）
    </h1>
    <table border="1" bordercolor="#000000">
      <tr>
        <td colspan="2" class="head-2">姓名</td>
        <td colspan="3" class="input-text1">
          {{ customer.name }}<br><input type="text" name="name" style="border:none;border-bottom:1.5px solid #555555;"
            class="no-border" v-model="customer.cardid" />
        </td>
        <td colspan="2" class="head-2 six_word">腾空时间</td>
        <td colspan="2" class="input-text1">{{ customer.empty_time }}</td>
        <td colspan="2" class="head-2 six_word">确认安置面积</td>
        <td colspan="2" class="input-text1">{{
          customer.myarea
        }}㎡</td>

      </tr>
      <tr>
        <td colspan="2" class="head-2">安置人员</td>
        <td colspan="11" class="input-text" style="text-align:left"> <input type="text" name="name"
            style="border:none;border-bottom:1.5px solid #555555;width:70%" class="no-border"
            v-model="customer.transition_user" /></td>
      </tr>
      <tr>
        <td colspan="2" class="head-2">总过渡费</td>
        <td colspan="2" class="input-text">{{ customer.transition.transition_total }}</td>

        <td class="input-text12">元</td>
        <td colspan="8" class="input-text"></td>
      </tr>
      <tr>
        <td colspan="2" class="head-2">已发放过渡费</td>
        <td colspan="2" class="input-text">{{ customer.transition.transition_issued }}</td>

        <td class="input-text12">元</td>
        <td colspan="8" class="input-text"></td>
      </tr>

      <tr>
        <td colspan="2" class="head-2">差价</td>
        <td colspan="2" class="input-text">{{ customer.transition.transition_diff }}</td>

        <td class="input-text12">元</td>
        <td colspan="8" style="text-align:left;">“-”代表超发过渡费，“+”代表需补发过渡费</td>
      </tr>

      <!-- <tr><td colspan="13"></td></tr> -->
      <tr>
        <td colspan="13" class="input-text2">过渡费明细表</td>
      </tr>
      <tr>
        <td class="head-2">序号</td>
        <td colspan="5" class="head-2">房号</td>
        <td class="head-2">面积</td>
        <td class="head-2">过渡月份</td>
        <td colspan="2" class="head-2">交房时间</td>
        <td colspan="2" class="head-2" v-if="customer.transition_status !== 1">过渡费</td>
        <td class="head-2">备注</td>

      </tr>
      <tr v-for="(detail, i) in customer.contracts" :key="i">
        <td class="head-4">{{ i + 1 }}</td>
        <td colspan="5" class="head-4">{{ detail.garden_name }} {{ detail.building_name }}幢 {{ detail.unit_name }}单元 {{
          detail.house_number }}室</td>
        <td class="head-4">{{ detail.area }}㎡</td>
        <td class="head-4">{{ detail.month }}</td>
        <td colspan="2" class="head-4">{{ detail.delivery_time_transition }}</td>
        <td colspan="2" class="head-4" v-if="customer.transition_status !== 1">{{ detail.transitionTotal }}</td>
        <td class="head-4">{{ detail.real_delivery_time == detail.delivery_time_transition ? '' : '实际拿房日期为' }} <br />{{ detail.real_delivery_time == detail.delivery_time_transition 
          ? '' : detail.real_delivery_time }}</td>

      </tr>

    </table>

    <v-row class="d-flex justify-space-between note-footer">
      <span style="display: inline-block; text-align: left;width: 50%">结算单位（盖章）：
        <!-- :value="user_name" -->
        <input type="text" name="name" style="border:none;border-bottom:1.5px solid #555555;" class="my-input" />
      </span>
      <span style="display: inline-block; text-align: right;width: 50%">户主签字：
        <!-- :value="user_name" -->
        <input type="text" name="name" style="border:none;border-bottom:1.5px solid #555555;" class="my-input" />
      </span>


    </v-row>
    <!-- <v-row>
        <v-col>
          <span style="padding-left:30px">注：以上内容面积单位为平方米(㎡)</span>
        </v-col>
      </v-row> -->
  </v-container>
</template>

<script>
import { fetchCustomer, updateCustomerById } from "@/api/customers";
import { getReaderInfo, readIDCard } from "@/api/idcard";
import { fetchCompanyList } from "@/api/companies";

const stateOptions = [
  { key: 0, display_name: "系统计算" },
  { key: 1, display_name: "拆迁公司计算" },
];

export default {
  name: "Bill Print",
  components: {
    AddRemindDialog: () => import("./addRemindDialog"),
    UpdateTransitionDialog: () => import("./updateTransitionDialog.vue"),
  },

  filters: {},
  data() {
    return {
      nowTime: '',
      styleText: '<style type="text/css">\n' + '  @page { size: portrait; }\n' + '</style>',
      customer: "",
      total_fee: "",
      seq: "",
      difference: "",
      transitionList: [],
      user_name: this.$store.getters.name,
      company: this.$store.getters.company,
      details: null,
      companyOptions: [],
      stateOptions,
      empty_menu:"",
      empty_time:"",
      // population_price: 580,
      // property_price: 960,
      // extend20_price: 3510,
      // market_discount_price: 6110,
      // market_price: 6110,
      dt_now: "",
      printObj: {
        id: "printMe",
        popTitle: "good print",
        extraCss: "https://www.baidu.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      cssBackgroundImg: {
        backgroundImage: `url(${require("@/assets/background.jpg")})`
      },
      icons: {
        remind: {
          color: "blue",
          icon: "mdi-alert"
        },
        
      },
    };
  },

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("admin")) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.getCompaniesList();
    this.getTransition(this.$route.params.id);
    this.dt_now = Date.now();
    this.seq = this.$route.params.seq;

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 补零
    const day = String(now.getDate()).padStart(2, '0');   
    this.nowTime =  `${year}-${month}-${day}`;    
  },

  methods: {
    goBack() {
      console.log("goback clicked");
      this.$router.go(-1);
    },
    confirm() {
      const customer = this.customer;
      var data = {};
      if (this.empty_time != ""){
        data = {
          'cardid': customer.cardid,
          'transition_user': customer.transition_user,
          'transition_is_company': customer.transition_is_company,
          'company_id': customer.company_id,
          'empty_time': this.empty_time
        }
      }else{
        data = {
        'cardid': customer.cardid,
        'transition_user': customer.transition_user,
        'transition_is_company': customer.transition_is_company,
        'company_id': customer.company_id
      }
      }
      
      // console.log(tempData);
      updateCustomerById(customer.id, data).then(response => {
        this.text = "数据保存成功";
        this.snackbar = true;
        this.getTransition(this.$route.params.id);
      });

    },
    getTransition(id) {
      this.listLoading = true;
      fetchCustomer(id).then(response => {
        this.customer = response.data;
        console.log("过渡费状态---", this.customer.transition_status)
        if (this.customer.transition_user == null) {
          this.customer.transition_user = this.customer.name
        }
        if (Number(this.customer.transition.transition_diff)==0){
          this.customer.transition.transition_diff = Number(this.customer.transition.transition_diff).toFixed(2);
        }
        // this.totalFeeIssued = response.data.totalFeeIssued;
        // this.total_fee = response.data.total_fee;
        // this.difference = response.data.difference;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },

    getCompaniesList() {
      this.listLoading = true;
      console.log("getCompaniesList");
      fetchCompanyList().then(response => {
        this.companyOptions = response.data.items;
        setTimeout(() => {
          this.listLoading = false;
        }, 5 * 1000);
      });
    },
    readerInit(wzxx) {

      if (this.websocket_supported == false || this.socket.readyState == 2 || this.socket.readyState == 3) {
        this.websocket_supported = this.wsOpen();
      }

      if (!this.jsonp_supported) {
        getReaderInfo().then(response => {
          console.log(response);
          if (response.status == 200) {
            this.jsonp_supported = true;
          } else {
            this.jsonp_supported = false;
          }

        });
      }
    },
    parseCardInfo(text) {
      var result = {};
      result['name'] = text.substr(0, 15).trim();
      result['gender'] = text.substr(15, 1).trim();
      result['race_id'] = text.substr(16, 2).trim();
      result['birthday'] = text.substr(18, 8).trim();
      result['address'] = text.substr(26, 35).trim();
      result['IDNumber'] = text.substr(61, 18).trim();
      result['issuer'] = text.substr(79, 15).trim();
      result['valied'] = text.substr(94, 8).trim();
      result['expire'] = text.substr(102, 8).trim();
      result['type'] = text.substr(124, 1).trim();

      if (result['type'] == 'J') {
        result['PassNumber'] = text.substr(110, 9);
        result['issueCount'] = text.substr(119, 2);
      }
      else if (result['type'] == 'I') {
        return false;
      }
      return result;
    },

    onWsOpen(evt) {
    },

    onWsClose(evt) {
    },

    onWsMessage(evt) {
      var jsondata = JSON.parse(evt.data);

      // this.writeToScreen(evt.data); 

      if (jsondata.module == "idcard" && jsondata.function == "readcard") {

        if (jsondata.ret != 0) {
          //alert(jsondata.errorMsg);
          return;
        }
        var result = this.parseCardInfo(jsondata.data.text);
        console.log("获取身份证数据");
        this.customer.cardid = result.IDNumber
      }
      else if (jsondata.module == "idcard" && jsondata.function == "getsam") {
        if (jsondata.ret != 0) {
          //alert(jsondata.errorMsg);
          return;
        }
      }
      else if (jsondata.module == "iccard" && jsondata.function == "getidsnr") {
        if (jsondata.ret != 0) {
          return;
        }
      }
      else {
        return false
      }
    },

    onWsError(evt) {
    },

    doSend(message) {
      this.socket.send(message);
    },
    wsOpen() {
      if (typeof (WebSocket) == "undefined") {
        return false;
      }

      let that = this
      this.socket = new WebSocket(this.wsUri);
      this.socket.onopen = function (evt) {
        that.onWsOpen(evt)
      };
      this.socket.onclose = function (evt) {
        that.onWsClose(evt)
      };
      this.socket.onmessage = function (evt) {
        that.onWsMessage(evt)
      };
      this.socket.onerror = function (evt) {
        that.onWsError(evt)
      };

      return true;
    },

    wsClose() {
      this.socket.close();
    },

    onJsopReadCard(resultInfo, status) {
      console.info("readIDCard ", resultInfo, status);
      // $("#output").text(JSON.stringify(resultInfo));
      if (resultInfo.result === 0) {

        var result = this.parseCardInfo(resultInfo.wzInfo);

      }
      else {
        //alert(resultInfo.errorMsg);
      }

    },

    getInfo() {
      this.msgid = this.msgid + 1;
      this.doSend("{\"module\":\"common\",\"msgid\":\"" + this.msgid + "\",\"function\":\"info\"}");
    },
    readIdCard() {
      this.is_entrust = false;
      // console.log("点击买受人数据");
      // console.log(this.is_entrust);
      this.msgid = this.msgid + 1;
      if (this.websocket_supported && this.socket.readyState == 1) {
        this.doSend("{\"module\":\"idcard\",\"msgid\":\"" + this.msgid + "\",\"function\":\"readcard\"}");
      }
      else if (this.jsonp_supported) {

        readIDCard().then(response => {
          this.onJsopReadCard()
        });
      }
      else {
        console.log("未检测到阅读器插件!");
      }

    },
  }
};
</script>

<style scoped>
.append-select>>>.v-label {
  color: #000 !important;
  font-size: 16px;
}

.append-select>>>.v-select__selection {
  color: #000;
  font-size: 16px;
}

.append-select>>>.v-icon {
  color: #000 !important;
}

.append-select>>>.primary--text {
  color: #000 !important;
  caret-color: #000 !important;
}

body {
  margin: auto;
  padding: auto;
  background: rgb(65, 63, 63);
}

.A4 {
  background: rgb(180, 180, 180);
  /* width: 21cm;
  height: 29.7cm; */
  width: 1122px;
  height: 794px;
  display: block;
  /* box-shadow: 0 0 1px 1px rgb(2, 164, 252); */
  overflow-y: auto;
  box-sizing: border-box;
  margin: auto;
}

.head-1 {
  margin-top: 0;
  padding: 0 0 20px 0;
  font-weight: 800;
  font-size: 21pt;
  text-align: center;
}

.head-2 {
  padding: 2pt;
  font-weight: 600;
  font-size: 12pt !important;
  text-align: center;
  background-color: rgb(136, 134, 132);
}

.head-3 {
  font-weight: 400;
  font-size: 12pt !important;
  color: white;
  text-align: center;
  background-color: rgb(249, 182, 0);
}

.head-4 {
  font-weight: 400;
  font-size: 11pt !important;
  text-align: center;
  background-color: rgb(59, 71, 230);
}

.input-text {
  font-weight: 600;
  font-size: 10pt;
  color: rgb(0, 0, 0);
}

.input-text1 {
  font-weight: 600;
  font-size: 10pt;
  color: rgb(0, 0, 0);
  text-align: center;
}

.input-text12 {
  font-weight: 600;
  font-size: 12pt;
  color: rgb(0, 0, 0);
  text-align: center;
}

.input-text2 {
  font-weight: 600;
  font-size: 12pt;
  color: rgb(0, 0, 0);
  text-align: left;
}

.input-text-red {
  font-weight: 700;
  font-size: 10pt;
  color: rgb(231, 5, 5);
}

.money {
  text-align: left;
  font-weight: 600;
  color: rgb(3, 54, 192);
  padding: 0 0 0 20px;
}

td {
  padding-top: 9px;
  padding-bottom: 6px;
  padding-left: 8px;
  padding-right: 8px;
}

table {
  margin: auto;
  text-align: right;
  width: 90%;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  justify-content: space-around;
}

.note-header {
  padding: 0px 30px 15px 40px;
}

.note-footer {
  padding: 20px 25px 10px 100px;
  width: 100%;
}

.my-input-header {
  margin: 0 500px 0 0;
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 230px;
}

.my-input {
  margin: 0 35px 0 0;
}

.sanjiaoxing {
  width: 0;
  height: 0;
  border-color: transparent rgb(231, 93, 93);
  border-width: 0 0 120px 120px;
  border-style: solid;
  position: absolute;
}

.sequence {
  margin: 0 0 5px 10px;
  padding: 0 5px 0 5px;
  position: absolute;
  /* background-color: rgb(172, 104, 104); */
  transform: rotate(-45deg);
  transform-origin: 20% 40%;
}



@page {
  /* size: A4; */
  /* size: landscape; */
  margin: 0;
}

/* @media print{@page {size: landscape}} */

@media print {
  .A4 {
    width: 964px;
    height: 1322px;
    background: white;
  }

  .head-2 {
    background-color: rgb(231, 229, 226);
  }

  .head-4 {
    background-color: rgb(231, 229, 226);
  }

  .my-header {
    height: 50px;
  }

  .my-btn {
    display: none;
  }

  .six_word {
    width: 120px;
  }

  .sanjiaoxing {
    display: none;
  }

  .sequence {
    display: none;
  }
}

@media print {
  .no-border {
    border-bottom: none !important;
  }

  .print-hidden {
    display: none;
  }
}
</style>
